export default {
  401: 'Either your email or password was incorrect. Please try again.',
  403: 'Either your email or password was incorrect. Please try again.',
  404: 'We could not find your email address. Please try again.',
  422: `Looks like there's already a Volusion account with that email address! We went ahead and linked your Volusion and Google accounts; from now on, you can log in to your store with Google or with your Volusion credentials. Please log in again to continue to your store.`,
  500: 'We are having technical difficulties. Try again in a few minutes, and if you still can\'t login please contact us.' //eslint-disable-line
};
